interface AccountRecoveryHeaderProps {
  title?: string;
  className?: string;
}

export function AccountRecoveryHeader({ 
  title = "계정정보 찾기",
  className = '' 
}: AccountRecoveryHeaderProps) {
  
  return (
    <div className={`text-center mb-12 ${className}`}>
      <h1 className="text-[32px] font-bold text-[#222222] mb-4">{title}</h1>
      <p className="text-[18px] text-gray-600">
        아이디나 비밀번호를 찾으시려면<br />
        아래 옵션을 선택해주세요
      </p>
    </div>
  );
}